import { FastColor } from "@ant-design/fast-color";
import { ThemeName } from "@dto/usersResponse.dto";
import { AliasToken, SeedToken } from "antd/es/theme/interface";

export const createHoverColor = (color: string): string => {
  return `color-mix(in hsl, ${color} 80%, white)`;
};

interface ColorVariables {
  /* *** Main *** */
  "xm-color-primary"?: string; //  Logo, titles, card headers
  "xm-color-primary-text"?: string;
  "xm-color-primary-hover"?: string;
  "xm-color-secondary"?: string; // Primary CTA, active states
  "xm-color-secondary-text"?: string;
  "xm-color-secondary-hover"?: string;
  "xm-color-tertiary"?: string; //  Icons - probably remove
  "xm-color-highlight"?: string;

  /* States */
  "xm-color-info"?: string;
  "xm-color-error"?: string;
  "xm-color-warning"?: string;

  /* *** General *** */
  "xm-color-text"?: string;
  "xm-color-text-oposite"?: string;
  "xm-color-scroll"?: string;
  "xm-bg-color-page"?: string;
  "xm-bg-color"?: string;
  "xm-bg-color-base"?: string;
  "xm-bg-color-light"?: string;
  "xm-bg-color-table-header"?: string;
  "xm-bg-secondary"?: string;
  "xm-border-color"?: string;

  /* Size */
  "xm-font-family"?: string;
  "xm-font-weight-medium"?: string;

  /* *** Login *** */
  "xm-login-bg-color"?: string;
  "xm-login-form-bg-color"?: string;
  "xm-login-color"?: string;

  /* *** Menu *** */
  "xm-logo-bg-color"?: string;
  "xm-logo-color"?: string;
  "xm-logo-separator-bg-color"?: string;

  "xm-menu-top-bg-color"?: string;
  "xm-menu-top-color"?: string;
  "xm-menu-top-underline-color"?: string;

  "xm-menu-left-bg-color"?: string;
  "xm-menu-left-color"?: string;
  "xm-menu-left-selected-bg-color"?: string;
  "xm-menu-left-selected-color"?: string;
  "xm-menu-left-hover-bg-color"?: string;
  "xm-menu-left-hover-color"?: string;
  "xm-menu-left-scroll-color"?: string;

  /* *** Dashboard *** */
  "xm-dashboard-header-bg-color"?: string;
  "xm-dahsboard-header-color"?: string;
  "xm-dashboard-body-bg-color"?: string;

  /* *** Xbot *** */
  "xm-xbot-header-bg-color": string;
  "xm-xbot-body-bg-color": string;
  "xm-xbot-border-color": string;

  /* *** Miscellaneous *** */
  "xm-fav-color"?: string;
}

const xmBaseVars: ColorVariables = {
  // /* *** Main *** */
  // "xm-color-primary": "#2b4f60", //  Logo, titles, card headers
  // "xm-color-primary-text": "#e2e9ed",
  // "xm-color-primary-hover": createHoverColor("var(--xm-color-primary)"),
  // "xm-color-secondary": "#233f4d", // Primary CTA, active states
  // "xm-color-secondary-text": "#ccdddd",
  // "xm-color-secondary-hover": "#000",
  // "xm-color-tertiary": "#3c6c84", //  Icons - probably remove
  "xm-color-highlight": '#48a',
  // States
  "xm-color-info": "#17a2b8",
  "xm-color-error": "#b00",
  "xm-color-warning": "chocolate",

  /* *** General *** */
  "xm-color-text": "#000",
  "xm-color-text-oposite": "#cdd",
  "xm-color-scroll": "#c4c4c9",
  "xm-bg-color-page": "#fafafa",
  "xm-bg-color": "var(--ant-color-bg-container)",

  "xm-bg-color-base": "color-mix(in hsl, var(--xm-color-primary) 30%, white)", // 46%
  "xm-bg-color-light": "color-mix(in hsl, var(--xm-bg-color-base) 94%, white)",
  "xm-bg-color-table-header": "color-mix(in hsl, var(--xm-bg-color-base) 96%, white)",
  "xm-bg-secondary": "var(--ant-color-bg-container)", // "var(--ant-color-bg-container)"

  "xm-border-color": "#dddddd",
  // Size
  "xm-font-family": "-apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  "xm-font-weight-medium": "600", // 500 looks in Firefox like 400

  // /* *** Login *** */
  "xm-login-bg-color": "var(--xm-color-primary)",
  "xm-login-form-bg-color": "var(--ant-color-bg-base)",
  "xm-login-color": "var(--xm-color-primary)",

  // /* *** Menu *** */
  // // Top
  // "xm-menu-top-bg-color": "var(--xm-bg-color)",
  // "xm-menu-top-color": "var(--xm-color-text)",
  // "xm-menu-top-underline-color": "var(--xm-bg-color)",
  // // Left
  // "xm-menu-left-bg-color": "var(--xm-color-secondary)",
  // "xm-menu-left-color": "#cdd",
  // "xm-menu-left-selected-bg-color": "#fff",
  // "xm-menu-left-selected-color": "#fff", //
  // "xm-menu-left-hover-bg-color": "",
  // // "xm-menu-left-hover-color": null, //
  // "xm-menu-left-scroll-color": "#c4c4c9",
  // "xm-logo-separator-bg-color": "var(--xm-color-primary)",

  /* *** Xbot *** */
  "xm-xbot-header-bg-color": "#f6fbff",
  "xm-xbot-body-bg-color": "#ffffff",
  "xm-xbot-border-color": "#d1dbe3",

  /* *** Miscellaneous *** */
  "xm-fav-color": "rgba(222, 200, 0, 0.7)"
};

const fontSize = 12;

const xmSeedToken: Partial<SeedToken> = {
  borderRadius: 4,
  // must use value, not reference to a variable e.g. var(--xm-color-lite)
  colorLink: xmBaseVars["xm-color-secondary"],
  fontSize,
  controlHeight: 28,
  // motion: false,
  motionUnit: 0.05,
  sizeStep: 2,
  // sizeUnit: 3
};

const xmCommonToken: Partial<AliasToken> = {
  ...xmSeedToken,
  colorLinkHover: xmBaseVars["xm-color-highlight"],
  controlOutlineWidth: 1,
  fontSizeSM: fontSize,
  fontSizeHeading1: 2 * fontSize,
  fontSizeHeading2: 1.75 * fontSize,
  fontSizeHeading3: 1.5 * fontSize,
  fontSizeHeading4: 1.25 * fontSize,
  fontSizeHeading5: 1.125 * fontSize,
  fontWeightStrong: Number(xmBaseVars['xm-font-weight-medium']),
  // lineHeight: 1.66667, // 1.5
  // controlHeight: 30,
  // controlHeightSM: 30,
  sizeXXL: 16,
  sizeXL: 14,
  sizeLG: 12,
  sizeMD: 12,
  sizeMS: 10,
  size: 8,
  sizeSM: 6,
  sizeXS: 4,
  sizeXXS: 2,
  // paddingContentVertical: 2,
  // paddingContentHorizontalSM: 1
};

const xmBlueVars: ColorVariables = {
  ...xmBaseVars,
  "xm-color-primary": "#002447", // #154360
  "xm-color-primary-text": "#cdd",
  "xm-color-secondary": "#094b94", // "#0f61bf", // #1068ce // #1a5276
  "xm-color-secondary-text": "#f2fffa",
  "xm-color-secondary-hover": createHoverColor("var(--xm-color-secondary)"),
  "xm-color-tertiary": "#002447", // #2471a3
  // "xm-color-highlight": "#8ac4ff", // #2980b9
  // "xm-menu-left-bg-color": "#eff7ff",
  // "xm-menu-left-color": "#333344", // "#333344"
  // "xm-menu-top-color": "var(--xm-color-text-oposite)", //
  "xm-color-highlight": "#094b94",
  "xm-color-scroll": "#95b0d0",

  "xm-bg-color-base": "#f5f7f8", // Dashboard bg
  "xm-bg-color-light": "#f9f9f9", // Exporter - form
  "xm-bg-color-table-header": "#f0f5f8", // State Timeline
  "xm-bg-secondary": "#fff", // Server - Graph

  /* *** Menu *** */
  "xm-logo-bg-color": "#002447",
  "xm-logo-color": "#ccdad8",
  // Top
  "xm-menu-top-bg-color": "#002447",
  "xm-menu-top-color": "#ccdad8",
  "xm-menu-top-underline-color": "#c7dbf1",
  // Left
  "xm-menu-left-bg-color": "linear-gradient(135deg, #f2f7fc 0%, #f5f8fc 100%)", // "#f5f8fd",// "#eff7ff",
  "xm-menu-left-color": "#333344",
  "xm-menu-left-selected-bg-color": "#e3ecfc", //"#c7dbf1",
  "xm-menu-left-selected-color": "#333344",
  "xm-menu-left-hover-bg-color": "#e3ecfc82",
  "xm-menu-left-scroll-color": "#c4c4c9",
  // "xm-logo-separator-bg-color": "#f5f8fc",//"#e7ecf8",//"#dceaf9",

  /* *** Dashboard *** */
  "xm-dashboard-header-bg-color": "#e3ecfc",
  "xm-dahsboard-header-color": "#002447",
  "xm-dashboard-body-bg-color": "",
};

const xmDarkVars: ColorVariables = {
  ...xmBaseVars,
  "xm-color-primary": "#444",
  "xm-color-secondary": "#4488aa",
  "xm-color-secondary-text": "#ededed",
  "xm-color-secondary-hover": createHoverColor("var(--xm-color-secondary)"),
  "xm-color-tertiary": "#555555", // Dashboard group title
  "xm-color-text": "#fff",
  // "xm-color-menu-scroll": "var(--ant-color-bg-base)",
  "xm-bg-color-page": "#222",
  "xm-bg-color": "#333",
  "xm-color-scroll": "#303030",
  "xm-login-bg-color": "#333",
  "xm-login-form-bg-color": "#444",
  "xm-login-color": "var(--ant-color-text-secondary)",
  // "xm-bg-secondary": "var(--xm-color-dark)",
  "xm-logo-separator-bg-color": "#333", // "#555555",
  "xm-border-color": "#222",

  "xm-bg-color-base": "#333333", // Dashboard bg
  "xm-bg-color-light": "#2a2a2a", // Exporter - form
  "xm-bg-color-table-header": "#333", // State Timeline
  "xm-bg-secondary": "#333", // Server - Graph

  /* *** Menu *** */
  "xm-logo-bg-color": "#333",
  "xm-logo-color": "#ccdddd",
  // Top
  "xm-menu-top-bg-color": "#333",
  "xm-menu-top-color": "#ccdddd", // var(--xm-color-text)
  // Left
  "xm-menu-left-bg-color": "#333",
  "xm-menu-left-color": "#ccdddd",
  "xm-menu-left-selected-bg-color": "#555555",
  "xm-menu-left-selected-color": "#ccdddd", //
  "xm-menu-left-hover-bg-color": "#444",
  // "xm-menu-left-hover-color": "#333344", //#d8e0e5
  "xm-menu-left-scroll-color": "#5a5959",

  /* *** Xbot *** */
  "xm-xbot-header-bg-color": "#333",
  "xm-xbot-body-bg-color": "#222",
  "xm-xbot-border-color": "#444",

  /* *** Dashboard *** */
  "xm-dashboard-header-bg-color": "",
  "xm-dahsboard-header-color": "",
  "xm-dashboard-body-bg-color": "",
};

const xmLightVars: ColorVariables = {
  ...xmBaseVars,
  "xm-color-primary": "#dee2e4", // "#c0c0ca"
  "xm-color-primary-text": "#333344",
  // "xm-color-secondary": "#eef0f1", // "#d8d8e2"
  "xm-color-secondary": "#2c6094",// "#094b94", // "#0f61bf", // #1a5276
  "xm-color-secondary-text": "#f2fffa",
  "xm-color-secondary-hover": createHoverColor("var(--xm-color-secondary)"),
  "xm-color-tertiary": "#b8bcbd", // "#6c6c84"
  "xm-color-highlight": "#2c6094",// "#2974ca", // "#8888a0"
  // "xm-color-menu-scroll": "#b8b8c8", // "#b8b8c8"

  "xm-bg-color-base": "#f5f5f6", // Dashboard bg
  "xm-bg-color-light": "#f9f9f9", // Exporter - form
  "xm-bg-color-table-header": "#f0f5f8", // State Timeline

  "xm-bg-secondary": "#fff", // Server - Graph

  /* *** Menu *** */
  "xm-logo-bg-color": "#e9ecf0",
  "xm-logo-color": "#333344",

  // Top
  "xm-menu-top-bg-color": "#e9ecf0",// "#eef0f1",
  "xm-menu-top-color": "#333344",
  // "xm-menu-top-underline-color": "#2e85e7",
  // Left
  "xm-menu-left-bg-color": "#f4f5f7",// "#eef0f1",
  "xm-menu-left-color": "#333344",
  "xm-menu-left-selected-bg-color": "#dee2e4",// "#d6dbdf",
  "xm-menu-left-selected-color": "#333344", //
  "xm-menu-left-hover-bg-color": "#e4e7e8",
  // "xm-menu-left-hover-color": "#333344", //#d8e0e5
  "xm-menu-left-scroll-color": "#c4c4c9",
  "xm-logo-separator-bg-color": "#e9ecf0", // "var(--xm-color-primary)",

  /* *** Dashboard *** */
  "xm-dashboard-header-bg-color": "#dee2e4",
  "xm-dahsboard-header-color": "#333344",
  // "xm-dashboard-body-bg-color": "#f1f4f5",

  // /* *** Login *** */
  "xm-login-bg-color": "#f4f5f7",
  "xm-login-form-bg-color": "#fff",
};

const xmOriginalVars: ColorVariables = {
  ...xmBaseVars,
  "xm-color-primary": "#2b4f60", // #17462a
  "xm-color-primary-text": "#ededed",
  "xm-color-secondary": "#3c6c84", // #1e5631
  "xm-color-secondary-text": "#ededed",
  "xm-color-secondary-hover": createHoverColor("var(--xm-color-secondary)"),
  "xm-color-tertiary": "#3c6c84", // #27ae60
  // "xm-color-highlight": "#48a", // #2ecc71

  "xm-bg-color-base": "#e2ecf2", // Dashboard bg
  "xm-bg-color-light": "#f7fafb", // Exporter - form
  "xm-bg-color-table-header": "#f0f5f8", // State Timeline
  "xm-bg-secondary": "#fff", // Server - Graph

  // "xm-logo-separator-bg-color": "#233f4d", //"#3c6c84",
  "xm-color-scroll": "var(--xm-color-secondary)",

  /* *** Menu *** */
  "xm-logo-bg-color": "#2b4f60",
  "xm-logo-color": "#ccdddd",
  // Top
  "xm-menu-top-bg-color": "#f0f5f8",
  "xm-menu-top-color": "#000", // var(--xm-color-text)
  // Left
  "xm-menu-left-bg-color": "#233f4d",
  "xm-menu-left-color": "#ccdddd",
  "xm-menu-left-selected-bg-color": "#3c6c84",
  "xm-menu-left-selected-color": "#ccdddd", //
  "xm-menu-left-hover-bg-color": "#2b4f60",
  // "xm-menu-left-hover-color": "#333344", //#d8e0e5
  "xm-menu-left-scroll-color": "#c4c4c9",

  /* *** Dashboard *** */
  "xm-dashboard-header-bg-color": "",
  "xm-dahsboard-header-color": "",
  "xm-dashboard-body-bg-color": "",
};

function makeLightToken(vars: typeof xmBaseVars): Partial<AliasToken> {
  const colorLite = new FastColor(vars["xm-color-secondary"]);
  const bg = colorLite.lighten(40); // 54
  return {
    ...xmCommonToken,
    colorLink: vars["xm-color-secondary"],
    colorLinkHover: vars["xm-color-highlight"],
    colorPrimary: vars["xm-color-secondary"], // primary
    colorPrimaryBg: bg.lighten(6).toHexString(),
    colorPrimaryBgHover: vars["xm-color-highlight"],
    controlItemBgActive: bg.lighten(4).toHexString(),
    controlItemBgHover: bg.toHexString(),
    colorBgBase: "#fafafa",
    colorTextBase: "#17191c",
    colorBgContainer: "#fff"
  };
}

function makeDarkToken(vars: typeof xmBaseVars): Partial<AliasToken> {
  return {
    ...xmCommonToken,
    colorLink: vars["xm-color-secondary"],
    colorLinkHover: vars["xm-color-highlight"],
    colorPrimary: vars["xm-color-secondary"],
    colorBgBase: "#1a1a1a",
    colorTextBase: "#ffffff",
    colorBgContainer: "#444444"
  };
}

// const xmDarkToken: Partial<AliasToken> = {
//   ...xmCommonToken,

//   colorPrimary: new FastColor(xmBaseVars["xm-color-primary"]).lighten(5).toHexString(),
//   colorBgBase: '#222', // xmDarkVars["xm-color-dark"],        // #333

//   colorSplit: xmDarkVars["xm-color-secondary"],          // #333
//   colorBorder: xmDarkVars["xm-color-secondary"],         // #555
// };

export interface ThemeVars {
  name: ThemeName;
  xmVars: typeof xmBaseVars;
  token: Partial<AliasToken>;
}

export const THEMES: Record<ThemeName, ThemeVars> = {
  blue: { name: 'blue', xmVars: xmBlueVars, token: makeLightToken(xmBlueVars) },
  dark: { name: 'dark', xmVars: xmDarkVars, token: makeDarkToken(xmDarkVars) },
  light: { name: 'light', xmVars: xmLightVars, token: makeLightToken(xmLightVars) },
  original: { name: 'original', xmVars: xmOriginalVars, token: makeLightToken(xmOriginalVars) },
} as const;

export function applyXmCssVars(theme: ThemeVars): void {
  const root = document.documentElement;
  const toRemove: string[] = [];
  for (const style of root.style) {
    if (style.startsWith('--xm-')) toRemove.push(style);
  }
  toRemove.forEach(prop => root.style.removeProperty(prop));
  for (const [key, value] of Object.entries(theme.xmVars)) {
    root.style.setProperty(`--${key}`, value);
  }
}